import { createdByInfo } from "../../../util/formatter";

export default {
  slug: "point_groups",
  endpoint: "point_groups/",
  titleKey: "point_groups_title",
  columns: [
    { field: "name", label: "f_name" },
    { label: "f_created_by", format: row => (row.created_by ? createdByInfo(null, row) : "—") },
  ],
  filters: [
    { name: "created_by", type: "me", label: "filter_created_by_me" },
    { name: "available_for_supervisors", entity: "created_by", label: "f_available_supervisors" },
    { name: "points", entity: "point", label: "f_points" },
  ],
  fields: [
    { name: "name", type: "text", label: "f_name", required: true },
    { name: "available_for_supervisors", type: "entity", entity: "created_by", isMulti: true, label: "f_available_supervisors", wide: true },
    { name: "points", type: "entity", entity: "point", isMulti: true, label: "f_points", wide: true },
  ],
  softDelete: true,
};
